<template>
  <Toast />
  <ConfirmDialog></ConfirmDialog>
  <ul class="list-none p-0 m-0 flex align-items-center font-medium mb-3">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer">Reportes</a>
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3 active"
        >Reporte de Facturas Elect&oacute;nicas Emitidas</span
      >
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <div
      class="flex align-items-center flex-column lg:justify-content-center lg:flex-row"
    >
      <h4>
        <strong
          >REPORTE GENERAL DE FACTURAS ELECTR&Oacute;NICAS EMITIDAS</strong
        >
      </h4>
    </div>
    <div class="col-12">
      <div class="card p-fondo">
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-3">
            <strong>SUCURSAL: </strong>
            <Dropdown
              v-model="sucursalSelected"
              :options="sucursales"
              optionLabel="nombre"
              optionValue="id"
            >
            </Dropdown>
          </div>
          <div class="field col-12 md:col-2">
            <strong>C&Oacute;DIGO FACTURA: </strong>
            <InputNumber
              v-model="codigoFactura"
              placeholder="Código Factura"
              :inputClass="'text-right'"
              :min="0"
              @keyup.enter="BuscarFiltro"
            />
          </div>
          <div class="field col-12 md:col-4">
            <strong>NOMBRE DE CLIENTE: </strong>
            <AutoComplete
              :dropdown="true"
              field="nombre_cliente"
              v-model="clienteSelected"
              :suggestions="clientesListadoFiltrado"
              @complete="buscarCliente($event)"
              placeholder="Buscar Cliente"
            />
          </div>
          <div class="field col-12 md:col-3">
            <strong>USUARIO/CAJERO: </strong>
            <Dropdown
              v-model="userSeleccionado"
              :options="users"
              optionLabel="name"
              optionValue="id"
            >
            </Dropdown>
          </div>
          <div class="field col-12 md:col-2">
            <strong>ESTADO DE FACTURA: </strong>
            <Dropdown
              v-model="estadoSelected"
              :options="estados"
              optionLabel="nombre"
              optionValue="id"
            >
            </Dropdown>
          </div>
          <div class="field col-12 md:col-2">
            <strong>TRABAJADOR: </strong>
            <Dropdown
              v-model="medicoSelected"
              :options="medicos"
              optionLabel="nombre_completo"
              optionValue="id"
            >
            </Dropdown>
          </div>
          <div class="field col-12 md:col-2">
            <strong>PAQUETES: </strong>
            <Dropdown
              v-model="paqueteSelected"
              :options="paquetes"
              optionLabel="nombre"
              optionValue="id"
            >
            </Dropdown>
          </div>
          <div class="field col-12 md:col-2">
            <strong>FECHA VENTA DESDE: </strong>
            <InputText
              type="date"
              v-model="fecha_inicio"
              dateFormat="dd/mm/yy"
            />
          </div>
          <div class="field col-12 md:col-2">
            <strong>FECHA VENTA HASTA: </strong>
            <InputText type="date" v-model="fecha_fin" dateFormat="dd/mm/yy" />
          </div>
          <div class="field col-12 md:col-2">
            <strong>ACCIONES: </strong>
            <Button
              label="BUSCAR"
              icon="pi pi-search"
              class="p-button-primary mr-2"
              v-tooltip.top="'Buscar'"
              :loading="enviando"
              :disabled="enviando"
              @click="BuscarFiltro"
            />
          </div>
        </div>
      </div>
      <div class="mt-2">
        <DataTable
          ref="dtFacturasElectronicas"
          key="id"
          :value="factura_electronicas"
          responsiveLayout="scroll"
          :loading="enviando"
          class="p-datatable-sm"
          :filters="buscar"
          responsive="true"
          stripedRows
          showGridlines
        >
          <template #header>
            <div
              class="flex flex-column md:flex-row md:justify-content-end md:align-items-end"
            >
              <span class="block mt-2 md:mt-0 p-input-icon-left mr-2">
                <i class="pi pi-search" />
                <InputText
                  v-model="buscar['global'].value"
                  placeholder="Buscar..."
                />
              </span>
              <span class="block mt-2 md:mt-0 p-input-icon-left">
                <Button
                  v-if="'R_Facturacion DescargarPDF' in auth.user.permissions"
                  label="PDF Imprimir"
                  icon="pi pi-file-pdf"
                  class="p-button-outlined p-button-danger mr-2"
                  v-tooltip.top="'Imprimir Reporte PDF'"
                  :loading="generandoPDF"
                  :disabled="generandoPDF"
                  @click="generarPDF"
                />
              </span>
              <span class="block mt-2 md:mt-0 p-input-icon-left">
                <Button
                  v-if="'R_Facturacion DescargarEXCEL' in auth.user.permissions"
                  label="EXCEL Exportar"
                  icon="pi pi-file-excel"
                  class="p-button-outlined p-button-success mr-2"
                  v-tooltip.top="'Imprimir Reporte Excel'"
                  :loading="exportando"
                  :disabled="exportando"
                  @click="exportFacturas"
                />
              </span>
            </div>
          </template>
          <template #loading>
            <div class="flex align-items-center justify-content-center">
              <ProgressSpinner />
            </div>
          </template>
          <template #empty>
            <span class="p-invalid text-center w-100">
              Debe aplicar filtros para ver resultados en la tabla!</span
            >
          </template>
          <Column field="venta_id" header="VENTA.ID"></Column>
          <Column field="id" header="NRO.FACT" :sortable="true">
            <template #body="{ data }">
              <span class="text-center">{{ data.id }}</span>
            </template>
          </Column>
          <!--  <Column field="sucursal" header="SUCURSAL">
            {{ data.sucursal }}
          </Column> -->
          <Column field="usuario" header="USUARIO" :sortable="true">
            {{ data.usuario }}
          </Column>

          <Column field="fecha_venta" header="FECHA VENTA"> </Column>
          <Column field="nombre_cliente" header="CLIENTE"> </Column>
          <Column field="nit" header="CI/NIT"> </Column>
          <Column
            v-if="false"
            field="descuento"
            header="DESC."
            class="text-right"
            :sortable="true"
          >
            <template #body="{ data }">
              {{ convertirNumeroGermanicFormat(data.descuento) }}
            </template>
          </Column>
          <Column
            field="total_cancelar"
            header="TOTAL"
            class="text-right"
            :sortable="true"
          >
            <template #body="{ data }">
              {{ convertirNumeroGermanicFormat(data.total_cancelar) }}
            </template>
          </Column>
          <Column field="nombre_medico" header="TRABAJADOR">
            <template #body="{ data }">
              {{ data.nombre_medico ?? "" }}
            </template>
          </Column>
          <Column field="nombre_paquete" header="PAQUETE" v-if="false">
            <template #body="{ data }">
              {{ data.nombre_paquete ?? "" }}
            </template>
          </Column>
          <Column field="estado" header="ESTADO">
            <template #body="{ data }">
              <span
                class="product-badge status"
                :class="{
                  'status-outofstock': data.estado === 0,
                  'status-instock': data.estado === 1,
                }"
              >
                {{ textoEstado(data.estado) }}
              </span>
            </template>
          </Column>
          <Column header="ACCIONES">
            <template #body="slotProps">
              <Button
                class="p-button-icon-only p-button-raised"
                icon="pi pi-ellipsis-v"
                v-tooltip.top="'Ver Acciones'"
                @click="$refs['menu' + slotProps.data.id].toggle($event)"
              />
              <Menu
                :ref="'menu' + slotProps.data.id"
                :popup="true"
                :model="acciones(slotProps.data)"
              >
              </Menu>
            </template>
          </Column>
        </DataTable>
        <Dialog
          v-model:visible="motivoAnulacionDialog"
          modal
          header="MOTIVO DE ANULACIÓN"
          :style="{ width: '400px' }"
        >
          <div class="p-fluid">
            <div class="p-field">
              <label for="motivo_anulacions"
                ><strong>SELECCIONE MOTIVO ANULACI&Oacute;N:</strong></label
              >
              <Dropdown
                id="motivo_anulacions"
                v-model="motivoAnulacionSelected"
                :options="motivo_anulacions"
                optionLabel="descripcion"
                optionValue="codigoClasificador"
                placeholder="Seleccione Motivo Anulación"
              />
            </div>
            <div class="p-field mt-2">
              <label for="solo_factura"
                ><strong>ANULAR SOLO FACTURA:</strong></label
              >
              <Checkbox
                class="ml-2 mt-2"
                v-model="solo_factura"
                :binary="true"
              />
            </div>
          </div>
          <div class="flex justify-content-end mt-4">
            <Button
              label="CANCELAR"
              icon="pi pi-times"
              class="p-button-success mr-2 p-button-lg"
              @click="motivoAnulacionDialog = false"
            />
            <Button
              label="ANULAR FACTURA"
              icon="pi pi-trash"
              class="p-button-danger p-button-lg"
              :loading="anulandoFactura"
              @click="anularVentaFactura(anularVentaId)"
            />
          </div>
        </Dialog>
      </div>
    </div>
  </div>
  <FacturaEstadoVerificacion
    v-if="modalVerificarEstado"
    v-model:visible="modalVerificarEstado"
    :datos="datosVerificacion"
    :loading="verificandoEstado"
    @closed="limpiarDatosVerificacion"
  />
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import VentaService from "@/service/VentaService";
import SucursalService from "@/service/SucursalService";
import UserService from "@/service/UserService";
import ClienteService from "@/service/ClienteService";
import { useAuth } from "@/stores";
import MedicoService from "@/service/MedicoService";
import PaqueteProductoService from "@/service/PaqueteProductoService";
import FacturaEstadoVerificacion from "@/module/facturas/FacturaEstadoVerificacion.vue";

export default {
  components: {
    FacturaEstadoVerificacion,
  },
  data() {
    return {
      fecha_inicio: new Date(new Date().getFullYear(), new Date().getMonth(), 1)
        .toISOString()
        .substr(0, 10),
      fecha_fin: new Date().toISOString().substr(0, 10),
      enviando: false,
      factura_electronicas: [],
      sucursalSelected: 0,
      sucursales: [{ id: 0, nombre: "TODAS" }],
      userSeleccionado: 0,
      users: [{ id: 0, name: "TODOS" }],
      medicoSelected: 0,
      medicos: [{ id: 0, nombre_completo: "TODOS" }],
      paqueteSelected: 0,
      paquetes: [{ id: 0, nombre: "TODOS" }],
      generandoPDF: false,
      exportando: false,
      buscar: {
        global: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
      },
      clienteSelected: null,
      clientesListadoFiltrado: [],
      estadoSelected: 2,
      estados: [
        { id: 2, nombre: "TODOS" },
        { id: 1, nombre: "VALIDA" },
        { id: 0, nombre: "ANULADA" },
      ],
      codigoFactura: null,
      motivo_anulacions: [],
      motivoAnulacionSelected: {},
      motivoAnulacionDialog: false,
      anularVentaId: null,
      solo_factura: false,
      anulandoFactura: false,

      // Variables para verificación de factura
      modalVerificarEstado: false,
      datosVerificacion: {},
      verificandoEstado: false,
    };
  },
  ventaService: null,
  sucursalService: null,
  userService: null,
  clienteService: null,
  auth: null,
  medicoService: null,
  paqueteProductoService: null,
  created() {
    this.ventaService = new VentaService();
    this.sucursalService = new SucursalService();
    this.userService = new UserService();
    this.clienteService = new ClienteService();
    this.auth = useAuth();
    this.medicoService = new MedicoService();
    this.paqueteProductoService = new PaqueteProductoService();
  },
  mounted() {
    this.cargarSucursales();
    this.cargarUsuarios();
    this.cargarMedicos();
    this.cargarPaqueteProductos();
    this.cargarMotivoAnulacion();
  },
  methods: {
    verificarEstado(datos) {
      this.modalVerificarEstado = true;
      this.verificandoEstado = true;

      this.ventaService
        .verificarEstadoFactura(datos.venta_id)
        .then((response) => {
          if (response.status == 200) {
            this.$toast.add({
              severity: "success",
              summary: "Éxito",
              detail: response.mensaje,
              life: 3000,
            });

            // Mapeo correcto según la estructura de tu API
            this.datosVerificacion = {
              venta_id: datos.venta_id,
              cuf: response.cuf, // CUF viene directo de response
              estado: response.estado, // Estado viene directo de response
              mensaje: response.mensaje,
              detalles: {
                success: response.detalles?.success,
                invoice: {
                  number: response.detalles?.invoice?.number,
                  total: response.detalles?.invoice?.total, // ⭐ Total aquí
                  createdAt: response.detalles?.invoice?.createdAt, // ⭐ Fecha aquí
                  cuf: response.detalles?.invoice?.cuf,
                  statusCode: response.detalles?.invoice?.statusCode,
                },
                siatResponse: {
                  codigoDescripcion:
                    response.detalles?.siatResponse?.codigoDescripcion,
                  codigoEstado: response.detalles?.siatResponse?.codigoEstado, // ⭐ Código estado aquí
                  transaccion: response.detalles?.siatResponse?.transaccion,
                  codigoRecepcion:
                    response.detalles?.siatResponse?.codigoRecepcion, // ⭐ Código recepción aquí
                },
              },
            };
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: response.mensaje,
              life: 3000,
            });
            this.modalVerificarEstado = false;
          }
        })
        .catch((error) => {
          this.modalVerificarEstado = false;
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: "No se pudo verificar el estado: " + (error.message || ""),
            life: 3000,
          });
        })
        .finally(() => {
          this.verificandoEstado = false;
        });
    },

    // Limpia los datos cuando se cierra el modal
    limpiarDatosVerificacion() {
      this.datosVerificacion = {};
    },

    cargarMotivoAnulacion() {
      this.ventaService.motivo_anulacions().then((data) => {
        this.motivo_anulacions = data.motivo_anulacions || [];
        this.motivoAnulacionSelected = this.motivo_anulacions.length
          ? this.motivo_anulacions[0].codigoClasificador
          : {};
      });
    },
    acciones(datos) {
      return [
        /* {
          label: "Ver Factura",
          icon: "pi pi-fw pi-eye",
          disabled:
            "Venta Ver Detalle" in this.auth.user.permissions ? false : true,
          to: `/showFactura/${datos.id}/detalle`,
        }, */
        {
          label: "Reimprimir Factura",
          icon: "pi pi-print",
          command: () => {
            this.imprimirVenta(datos.venta_id);
          },
        },
        /* {
          label: "Anular Factura",
          icon: "pi pi-times",
          command: () => {
            this.anularVenta(datos.venta_id);
          },
        }, */
        {
          label: "Anular Factura",
          icon: "pi pi-fw pi-trash",
          tooltip: "Anular Factura",
          disabled:
            datos.estado == 0
              ? true
              : false || "Venta Anular" in this.auth.user.permissions
              ? false
              : true,
          /* visible: datos.facturado == 1 ? true : false, */
          command: () => this.motivoAnulacionDialogConfirm(datos),
        },
        {
          label: "Verificar Estado",
          icon: "pi pi-fw pi-check",
          command: () => this.verificarEstado(datos),
        },
      ];
    },

    imprimirVenta(id) {
      this.ventaService
        .imprimirVenta(id)
        .then(() => {})
        .catch((error) => console.log(error));
    },
    motivoAnulacionDialogConfirm(datos) {
      this.anularVentaId = datos.venta_id;
      this.motivoAnulacionDialog = true;
      this.anulandoFactura = false;
      this.solo_factura = false;
    },
    anularVentaFactura(id) {
      this.anulandoFactura = true;
      let datos = {
        id: id,
        motivoAnulacion: this.motivoAnulacionSelected,
        anular_solo_factura: this.solo_factura,
      };
      this.ventaService.anularVenta(id, datos).then((response) => {
        this.anulandoFactura = false;
        if (response.status == 200) {
          this.$toast.add({
            severity: "success",
            summary: "Éxito",
            detail: response.mensaje,
            life: 9000,
          });
          this.cargarReporteFacturas();
          this.motivoAnulacionDialog = false;
          this.anulandoFactura = false;
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: response.mensaje,
            life: 9000,
          });
          this.anulandoFactura = false;
        }
      });
    },
    /* imprimirVenta(id) {
      this.ventaService
        .imprimirVentaFactura(id)
        .then(() => {})
        .catch((error) => console.log(error));
    }, */
    /* anularVenta(id) {
      this.$confirm.require({
        message: "¿Está seguro que desea anular la venta?",
        header: "Anular Venta",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si, deseo Anular",
        rejectLabel: "No, Cancelar",
        accept: () => {
          this.ventaService.anularVenta(id).then((response) => {
            if (response.status == 200) {
              this.$toast.add({
                severity: "success",
                summary: "Éxito",
                detail: response.mensaje,
                life: 3000,
              });
              // hago que aplique el filtro
              this.BuscarFiltro();
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: response.mensaje,
                life: 3000,
              });
            }
          });
        },
      });
    }, */
    textoEstado(estado) {
      if (estado == 0) {
        return "ANULADA";
      } else if (estado == 1) {
        return "VALIDA";
      } else {
        return "PENDIENTE";
      }
    },
    buscarCliente(event) {
      setTimeout(() => {
        this.clienteService
          .buscarXNombreConFactura({ texto: event.query })
          .then((response) => {
            this.clientesListadoFiltrado = [...response.clientes];
          })
          .catch((error) => console.log(error));
      }, 250);
    },
    exportFacturas() {
      if (this.factura_electronicas.length > 0) {
        let datos = {
          sucursal_id: this.sucursalSelected,
          user_id: this.userSeleccionado,
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          cliente_id: this.clienteSelected,
          estado: this.estadoSelected,
          codigoFactura: this.codigoFactura,
          medico_id: this.medicoSelected,
          nombre_paquete: this.paqueteSelected,
        };
        this.ventaService.exportarRFacturasElectronicas(datos).then(() => {
          this.exportando = false;
          this.$toast.add({
            severity: "success",
            summary: "Exportación exitosa",
            detail: "Se ha exportado correctamente",
            life: 3000,
          });
        });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Advertencia",
          detail: "No hay datos para exportar",
          life: 3000,
        });
      }
    },
    generarPDF() {
      if (this.factura_electronicas.length > 0) {
        this.generandoPDF = true;
        let datos = {
          sucursal: this.sucursalSelected,
          user_id: this.userSeleccionado,
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
          cliente_id: this.clienteSelected ? this.clienteSelected.id : null,
          estado: this.estadoSelected,
          codigoFactura: this.codigoFactura,
          medico_id: this.medicoSelected,
          nombre_paquete: this.paqueteSelected,
        };
        this.ventaService.imprimirRFacturasElectronicasPDF(datos).then(() => {
          this.generandoPDF = false;
          this.$toast.add({
            severity: "success",
            summary: "Exito",
            detail: "Se genero el PDF correctamente",
            life: 3000,
          });
        });
      } else
        this.$toast.add({
          severity: "warn",
          summary: "Advertencia",
          detail: "No hay datos para generar el reporte",
          life: 3000,
        });
    },
    cargarMedicos() {
      this.medicoService
        .getMedicosAll()
        .then((data) => {
          if (data && data.medicos && Array.isArray(data.medicos)) {
            this.medicos = [...data.medicos];
            this.medicos.unshift({ id: 0, nombre_completo: "TODOS" });
          } else {
            this.medicos = [{ id: 0, nombre_completo: "TODOS" }];
          }
        })
        .catch((error) => {
          console.error("Error cargando médicos:", error);
          this.medicos = [{ id: 0, nombre_completo: "TODOS" }];
        });
    },

    cargarPaqueteProductos() {
      this.paqueteProductoService
        .getPaqueteProductoAll()
        .then((data) => {
          if (
            data &&
            data.paqueteproductos &&
            Array.isArray(data.paqueteproductos)
          ) {
            data.paqueteproductos.forEach((element) => {
              this.paquetes.push(element);
            });
          }
        })
        .catch((error) => {
          console.error("Error cargando paquetes:", error);
        });
    },

    cargarUsuarios() {
      this.userService
        .getUsersAll()
        .then((data) => {
          if (data && Array.isArray(data)) {
            data.forEach((element) => {
              this.users.push(element);
            });
          }
        })
        .catch((error) => {
          console.error("Error cargando usuarios:", error);
        });
    },

    cargarSucursales() {
      this.sucursalService
        .getSucursalesAll()
        .then((data) => {
          if (data && Array.isArray(data)) {
            data.forEach((sucursal) => {
              this.sucursales.push(sucursal);
            });
          }
        })
        .catch((error) => {
          console.error("Error cargando sucursales:", error);
        });
    },
    BuscarFiltro() {
      /* alert("ESTA FUNCIONALIDAD NO ESTA DISPONIBLE, ESPERE UNA NUEVA VERSION"); */
      this.factura_electronicas = [];
      this.enviando = true;
      this.cargarReporteFacturas();
    },
    cargarReporteFacturas() {
      let datos = {
        sucursal_id: this.sucursalSelected,
        fecha_inicio: this.fecha_inicio,
        fecha_fin: this.fecha_fin,
        user_id: this.userSeleccionado,
        cliente_id: this.clienteSelected ? this.clienteSelected : null,
        estado: this.estadoSelected,
        codigoFactura: this.codigoFactura,
        medico_id: this.medicoSelected,
        nombre_paquete: this.paqueteSelected,
      };
      this.ventaService
        .filtros_factura_electronicas(datos)
        .then((data) => {
          this.factura_electronicas = data.factura_electronicas;
          this.enviando = false;
        })
        .catch((error) => {
          this.enviando = false;
          console.log(error);
        });
    },
    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat("de-DE").format(numero);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";

.p-invalid {
  color: red;
}

.p-fondo {
  background-color: #7bffae;
}
</style>
